import { Injectable } from '@angular/core';
import { NgxCvbspAuthorToolService } from '@vlemaitre/ngx-cvbsp-author-tool';

@Injectable({
  providedIn: 'root'
})
export class NgxPlayerVideoCreateService {
  /** add url to upload file, this url must return a response in the following format { data : { externalUrl : '<url_to_pict>' }} */
  urlToUpload: string;
  constructor(private authorToolService: NgxCvbspAuthorToolService) {
    this.setTranslations();
  }

  setTranslations() {
    this.authorToolService.translations.fr.NgxPlayerVideoComponent = 'Vidéo';
    this.authorToolService.translations.fr.REPLACE_VIDEO = 'Remplacer la vidéo';
    this.authorToolService.translations.fr.VIDEO_WIDTH = 'Largeur de la vidéo (% ou px)';
    this.authorToolService.translations.fr.VIDEO_HEIGHT = 'Hauteur de la vidéo (% ou px)';
    this.authorToolService.translations.fr.SHOW_INTRO = 'Montrer l\'introduction';
    this.authorToolService.translations.fr.NEXT_WHEN_FINISHED = 'Passer à la suite dès que la vidéo est terminée';
    this.authorToolService.translations.fr.AUTOPLAY = 'Lancer automatiquement la vidéo';
  }
}
